import {
  CREATECUSTOMER,
  DELETECUSTOMER,
  LISTOFCUSTOMER,
  UPDATECUSTOMER,
  VIEWCUSTOMER,
} from "./ApiRoutes";
import { authData } from "./services";

export const createCustomer = async (data: object) => {
  const response = await authData.post(CREATECUSTOMER, data);
  return response?.data;
};
export const updateCustomer = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATECUSTOMER}${id}`, data);
  return response?.data;
};
export const listOfCustomer = async (data: object) => {
  const response = await authData.post(LISTOFCUSTOMER, data);
  return response?.data;
};
export const viewCustomer = async (id: number) => {
  const response = await authData.get(`${VIEWCUSTOMER}${id}`);
  return response?.data;
};
export const deleteCustomerApi = async (id: number) => {
  const response = await authData.delete(`${DELETECUSTOMER}${id}`);
  return response?.data;
};
